module.exports = __webpack_public_path__ + "img/urun-bg.2abcada3.jpg";